import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { fmtNum } from "@/lib/format";
import { PageHeader, NativeSelect, LoadingBlock, EmptyState } from "@/components/Shared";

const STATUS_STYLE = { active: "text-emerald-700", completed: "text-sky-700", on_hold: "text-amber-700", archived: "text-slate-500" };

export default function Projects() {
  const [list, setList] = useState(null);
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ client_id: "", status: "" });
  useEffect(() => { api.get("/clients").then((r) => setClients(r.data)); }, []);
  useEffect(() => {
    api.get("/projects", { params: Object.fromEntries(Object.entries(f).filter(([, v]) => v)) }).then((r) => setList(r.data));
  }, [f]);

  return (
    <div className="fade-up">
      <PageHeader eyebrow="Jobs" title="Projects" actions={<Link to="/admin/projects/new" className="btn-brand h-11" data-testid="add-project-button"><Plus className="h-4 w-4" />Add project</Link>} />
      <div className="panel mb-4 grid gap-2 p-3 sm:grid-cols-2 lg:w-2/3">
        <NativeSelect className="h-11 text-sm" value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })} aria-label="Filter by client" data-testid="projects-filter-client">
          <option value="">All clients</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </NativeSelect>
        <NativeSelect className="h-11 text-sm" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} aria-label="Filter by status" data-testid="projects-filter-status">
          <option value="">All statuses</option><option value="active">Active</option><option value="on_hold">On hold</option><option value="completed">Completed</option><option value="archived">Archived</option>
        </NativeSelect>
      </div>
      {!list ? <LoadingBlock /> : !list.length ? <EmptyState title="No projects found" testId="projects-empty" /> : (
        <div className="panel overflow-x-auto">
          <table className="w-full min-w-[760px] text-sm" data-testid="projects-table">
            <thead><tr className="border-b border-border bg-slate-50 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500">
              <th className="px-4 py-3">Project</th><th className="px-4 py-3">Job #</th><th className="px-4 py-3">Client</th><th className="px-4 py-3">Location</th>
              <th className="px-4 py-3 text-right">Pipeline ft</th><th className="px-4 py-3 text-right">Reports</th><th className="px-4 py-3">Status</th>
            </tr></thead>
            <tbody>
              {list.map((p) => (
                <tr key={p.id} className="border-b border-border last:border-0 hover:bg-[#5C241E]/[0.03]">
                  <td className="px-4 py-3 font-semibold"><Link to={`/admin/projects/${p.id}`} className="hover:text-[#5C241E] hover:underline" data-testid={`project-link-${p.id}`}>{p.name}</Link></td>
                  <td className="px-4 py-3 font-mono-num">{p.job_number || "—"}</td>
                  <td className="px-4 py-3">{p.client_name}</td>
                  <td className="px-4 py-3 text-slate-600">{p.location || "—"}</td>
                  <td className="px-4 py-3 text-right font-mono-num">{fmtNum(p.total_footage)}</td>
                  <td className="px-4 py-3 text-right font-mono-num"><Link to={`/admin/reports?project_id=${p.id}`} className="hover:underline" data-testid={`project-reports-${p.id}`}>{p.report_count}</Link></td>
                  <td className={`px-4 py-3 text-xs font-bold uppercase ${STATUS_STYLE[p.status]}`}>{p.status.replace("_", " ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
